import { TrackingPageModel } from '../tracking-page.model';
import {
  getAppImage,
  getAsset,
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white,
  getProductItems
} from './helpers';

export const play: TrackingPageModel = {
  languageMenu: getLanguageMenu('Nunito', '#111111ff'),
  searchPageInput: {
    backgroundColor: '#FFFFFF',
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Nunito', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Nunito', '#111111ff')
  },
  background: {
    color: '#fbedd0ff',
    useBackgroundImage: false,
    imageUrl: getAppImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#a5674dff',
    linksUnderline: false,
    backgroundColor: white,
    headerBackground: white,
    footerBackground: white,
    borderColor: '#a5674d33',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Nunito', '#111111ff')
  },
  orderCard: {
    borderRadius: 0,
    borderWidth: 1,
    borderColor: '#a5674d33',
    backgroundColor: white,
    shadow: 'none',
    footerBackground: white,
    headerBackground: white,
    linksColor: '#a5674dff',
    linksUnderline: false,
    ...getFontConfig('Nunito', '#111111ff')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Palanquin Dark', '#111111ff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 19,
    ...getFontConfig('Quicksand', '#000000ff')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Nunito', '#111111ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Nunito', '#111111ff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#a5674d33',
    borderRadius: 0,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#ffffff',
      borderColor: '#7e613eff',
      borderRadius: 0,
      borderWidth: 1,
      shadow: 'none',
      ...getFontConfig('Quicksand', '#6b3313ff')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: '#ffffff00',
      borderColor: '#a5674d33',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 22,
        ...getFontConfig('Nunito', '#111111ff')
      },
      info: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Nunito', '#111111ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#ffffff00',
    borderColor: '#111111ff',
    borderRadius: 0,
    borderWidth: 2,
    shadow: 'none',
    ...getFontConfig('Nunito', '#111111ff')
  },
  detailsButton: {
    on: null,
    backgroundColor: '#a5674dff',
    borderColor: '#00ccff00',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Nunito', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#a5674dff',
    borderColor: '#ee7227',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Nunito', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/5c98e4e373d1a_logo-195x.png')),
  socialIcons: getSocialIcons('#111111ff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: white,
    borderColor: '#a5674d33',
    borderRadius: 0,
    borderWidth: 1,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Palanquin Dark', '#111111ff')
  },
  footer: {
    linksColor: '#a5674dff',
    linksUnderline: false,
    backgroundColor: white,
    ...getFontConfig('Nunito', '#111111ff'),
    ...getFooterItems()
  },
  header: {
    backgroundColor: '#fbedd0ff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#a5674d33',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#a5674d33',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#a5674dff',
        borderColor: '#00ccff00',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Nunito', white)
      },
      buttonText: 'BUY NO',
      title: {
        alignment: 'center',
        fontSize: 22,
        ...getFontConfig('Quicksand', '#000000ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Nunito', '#111111ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Nunito', '#111111ff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#a5674dff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#a5674d33',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#a5674d33',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#a5674dff',
        borderColor: '#00ccff00',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Nunito', white)
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'center',
        fontSize: 11,
        ...getFontConfig('Nunito', '#111111ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Nunito', '#111111ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Nunito', '#111111ff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#a5674dff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
